"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChevronButton = ChevronButton;
exports["default"] = void 0;
var _ChevronLeft = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronLeft"));
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledButtonChevron = _interopRequireDefault(require("./styled-button-chevron"));
var _utils = require("./utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var useCallback = _react["default"].useCallback;
var CHEVRON_LEFT_ICON = /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], null);
var CHEVRON_RIGHT_ICON = /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null);
var propTypes = {
  label: _propTypes["default"].string.isRequired,
  currentPage: _propTypes["default"].number.isRequired,
  numberOfPages: _propTypes["default"].number.isRequired,
  callback: _propTypes["default"].func,
  seoHref: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool])
};
var defaultProps = {
  callback: undefined,
  seoHref: false
};
function ChevronButton(_ref) {
  var label = _ref.label,
    currentPage = _ref.currentPage,
    numberOfPages = _ref.numberOfPages,
    callback = _ref.callback,
    seoHref = _ref.seoHref;
  var chevronIcon = label === _utils.PREVIOUS_PAGE ? CHEVRON_LEFT_ICON : CHEVRON_RIGHT_ICON;
  var isFirst = label === _utils.PREVIOUS_PAGE && currentPage === 1;
  var isLast = label === _utils.NEXT_PAGE && currentPage === numberOfPages;
  var onClickHandler = useCallback(function (event) {
    if (seoHref) event.preventDefault();
    if (callback) {
      var page = label === _utils.NEXT_PAGE ? currentPage + 1 : currentPage - 1;
      callback(event, page);
    }
  }, [callback, label, currentPage]);
  return /*#__PURE__*/_react["default"].createElement(_styledButtonChevron["default"], {
    icon: chevronIcon,
    onClick: onClickHandler,
    fullWidth: false,
    variant: "tertiary",
    disabled: isFirst || isLast,
    href: seoHref
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, label));
}
ChevronButton.propTypes = propTypes;
ChevronButton.defaultProps = defaultProps;
ChevronButton.displayName = 'ChevronButton';
var _default = exports["default"] = ChevronButton;